import  React, {Component} from 'react';
import _ from 'lodash';
import {isDesktop} from '../../../logic/utils';
import {Table, Thead, Tbody, Tr, Td, Th} from 'reactable';
import {Col, Row, Container} from '../../Common/reactstrap/lib';
import TableSupplier from '../../Cart/elements/tableElements/TableSupplier';

import ModalAddCart from '../../Cart/ModalAddCart'

class Results extends Component {
  render() {
    //console.log('Results');
    let results = this.props || {},
      hasOriginal = results.data.length > 0 && results.data[0].offers.length > 0,
      data = hasOriginal ? results.data  : [
          {
            offers: [
              {
                deliveryTerms: ' ',
                detailId: null,
                price: ' ',
                priceLogo: null,
                quantity: ' '
              }]
          }
        ],
      tableRows = _.map(_.sortBy(data, ['detail["brandName"]']), (values, indexes) => {
        let header = (values.detail) ? <Row>
            <Col sm="6">
              {values.detail.brandName} <a className="link" href={`search?article=${values.detail.article}`}>{values.detail.article}</a>
            </Col>
            <Col sm="5">
              {values.detail.name}
            </Col>
          </Row> : <span>Предложения отсутствуют</span>,

          offers = _.map(_.sortBy(values.offers, ['price']), (value, index) => {
            let isFirstCell = index == 0,
              toCart = {
                detail: values.detail,
                offer: value,
                description: ''
              };

            return (
              <Tr key={index}>
                {(isDesktop() && isFirstCell) &&
                <Td column={results.name[0]} rowSpan={values.offers.length}>
                  {header}
                </Td>}

                <Td column={results.name[1]}>
                  {value.priceLogo ? <TableSupplier logo={value.priceLogo} rating={value.rating}/> : ' '}
                </Td>
                <Td column={results.name[2]}>
                  {value.quantity.toLocaleString()}
                </Td>
                <Td column={results.name[3]}>
                  {value.deliveryTerms}
                </Td>
                <Td column="Цена, &#8381;">
                  {value.price.toLocaleString()}
                </Td>
                <Td column="">
                  {value.detailId ?
                    <ModalAddCart className="modal-c" data={toCart}/>
                     : ' '}
                </Td>
              </Tr>
            );
          });

        if (!isDesktop())
          return (
            <Table className={'table hide-empty-cell results ' + results.className}
                   noDataText="Предложения отсутствуют">
              <Tr>
                <Td column={results.name[0]} colSpan={6}>
                  {header}
                </Td>
              </Tr>
              {offers}
            </Table>
          );
        else return offers;
      });

    if (!isDesktop()) return (
      <div>
        {tableRows}

      </div>

    );

    else return (
      <div>
        { this.props.article && <h2>Результаты поиска артикула { this.props.article }
        </h2>}
        <Table className={'table hide-empty-cell results ' + results.className + (!hasOriginal && ' no-border') }>
          {tableRows}

        </Table>
      </div>
    );
  }
}

export default Results;



/** WEBPACK FOOTER **
 ** ./src/components/Search/elements/Results.jsx
 **/